class InputSanitizer {
  static presets = {
    'app-name': {
      clean: str => str.replace(/[^\p{L}\p{N}\s\-.,'!&()]/gu, '').slice(0, 30)
    },
    'short-name': {
      clean: str => str.replace(/[^\p{L}\p{N}\s\-.,'!&()]/gu, '').slice(0, 15)
    },
    'version': {
      clean: str => str.replace(/[^\p{L}\p{N}.-]/gu, '').slice(0, 20)
    },
    'path': {
      clean: str => str
        .replace(/[^\p{L}\p{N}._/-]+/gu, '')
        .replace(/\/{2,}/g, '/')
        .replace(/^\.+/, '')
        .replace(/\.+$/, '')
    },
    'start-page': {
      clean: str => {
        let s = str
          .replace(/[^\p{L}\p{N}._/?=&-]/gu, '')
          .replace(/\/{2,}/g, '/');
        if (!s.startsWith('/')) s = '/' + s;
        return s;
      }
    }
  };

  constructor(field, type, hintEl, showHintFn) {
    const preset = InputSanitizer.presets[type];
    if (!preset) return;
    if (!field) return;
    this.field = field;
    this.pattern = preset.pattern;
    this.cleaner = preset.clean;
    this.hintEl = hintEl;
    this.showHintFn = showHintFn || (()=>{});
    this.bind();
  }

  bind() {
    this.field.addEventListener('beforeinput', e => this.handleBeforeInput(e));
  }

  handleBeforeInput(e) {
    const type = e.inputType;
    if (type !== 'insertText' && type !== 'insertFromPaste') return;

    const source = e.inputType === 'insertFromPaste'
      ? e.dataTransfer?.getData('text') || e.data
      : e.data || '';

    const value = this.field.value;
    const proposed = value.slice(0, this.field.selectionStart) + source + value.slice(this.field.selectionEnd);
    const cleaned = this.cleaner(proposed);
    const cleanedSource = this.cleaner(source);

    if (cleaned !== proposed) {
      e.preventDefault();
      this.field.value = cleaned;
    }
    if(cleanedSource !== source){
      this.showHintFn(this.hintEl);
    }
  }
}

export default InputSanitizer;